<!--
Author: TangChen
Date: 2019-02-26
Desc: 绘制组合基金表格，为公共组件
-->
<template>
    <div class="comp-combo-list comp">
        <el-table
            v-if="fundArr.length >= 0"
            :data="fundArr"
            class="tab-list-tit"
            style="width: 100%"
            :row-key="getRowKeys"
            :expand-row-keys="expands"
            v-on:expand-change="expendTable"
        >
            <el-table-column label="组合代码" prop="combinationcode" width="120" align="center" />
            <el-table-column label="产品描述" prop="funddesc" />
            <el-table-column type="expand" label="查看明细" width="200">
                <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand">
                        <el-table
                            :data="props.row.fundArr"
                            class="tab-list-tit"
                            style="width: 100%"
                        >
                            <el-table-column
                                label="基金代码"
                                prop="fundcode"
                                width="120"
                                align="center"
                            />
                            <el-table-column label="基金名称" prop="fundname" />
                            <el-table-column label="投资比例" prop="comrate" align="center">
                                <template slot-scope="scope">
                                    <span v-cloak>{{ scope.row.comrate * 100 + "%" }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="风险等级" align="center" min-width="120">
                                <template slot-scope="scope">
                                    <span v-cloak style="white-space: nowrap">
                                        {{ $cache.getDict("110143", scope.row.risklevel) }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column label="基金净值" prop="nav" align="center">
                                <template slot-scope="scope">
                                    <span v-cloak>{{ $util.fmtNum(scope.row.nav, 4) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="更新时间" prop="fundname" align="center">
                                <template slot-scope="scope">
                                    <span v-cloak>{{ $util.fmtDate(scope.row.navdate) }}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="200" align="center">
                <template slot-scope="scope">
                    <el-tooltip
                        v-if="scope.row.isBuy"
                        class="item"
                        effect="info"
                        :content="scope.row.isBuy"
                        placement="left"
                    >
                        <el-button v-cloak type="lock" size="small">
                            组合{{ flag === "1" ? "定投" : "申购" }}
                        </el-button>
                    </el-tooltip>
                    <el-button
                        v-else
                        v-cloak
                        type="yellow"
                        size="small"
                        class="combo-buy"
                        v-on:click.prevent="newCombo(scope.row.combinationcode)"
                    >
                        组合{{ flag === "1" ? "定投" : "申购" }}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
export default {
    name: "ComboList",
    props: {
        flag: {
            type: String,
            default: "2"
        }
    },
    data() {
        return {
            fundArr: [],
            expands: []
        };
    },
    mounted() {},
    methods: {
        // 展开指定行
        expendTable(row) {
            if (row.combinationcode !== this.expands[0]) {
                this.expands = [];
                this.expands.push(row.combinationcode);
            } else {
                this.expands = [];
            }
        },
        getRowKeys(row) {
            return row.combinationcode;
        },
        // 修改组合定投基金，更新选中数据
        newCombo(code) {
            const _x = this.fundArr.filter((item) => {
                return item.combinationcode === code;
            })[0];
            const _y = this.$util.getObjParam(
                _x,
                "tano,fundcode,fundname,comrate,sharetype,investkind,investterm,combinationcode,combinationflag"
            );
            this.$emit("combo-list", _y);
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-combo-list {
    .el-table th {
        background-color: $bg5;
    }
    .el-table td div {
        width: 100%;
    }
    .el-table__expanded-cell[class*="cell"],
    .demo-table-expand {
        padding: 0;
    }
    .demo-table-expand {
        max-height: 300px;
        .el-table--fit {
            margin-bottom: 0;
            &:before {
                height: 0;
            }
            th > .cell {
                color: $color-b;
                font-weight: normal;
            }
            td {
                border: none;
                padding: 8px 0;
            }
        }
    }
}
</style>
